
export const redirectLinks = {
    triointernationalHome: "https://www.triointernational.net",

    // International Destinations
    azerbaijan : "https://www.triointernational.net/international/azerbaijan",
    georgia : "https://www.triointernational.net/international/georgia",
    hongkongMacau: "https://www.triointernational.net/international/hongkong-macau",
    indonesiaBali: "https://www.triointernational.net/international/indonesia-bali",
    israelJordan: "https://www.triointernational.net/international/israel-jordan",
    philippines: "https://www.triointernational.net/international/philippines",
    vietnam: "https://www.triointernational.net/international/vietnam"
}; 